import React from "react";
import PosTerminalGenericSkeleton from "./PosTerminalGenericSkeleton";

function PosTerminalDetailSkeleton() {
  return (
    <>
      <PosTerminalGenericSkeleton />
    </>
  );
}

export default PosTerminalDetailSkeleton;
